(function() {
  if (!window.dataLayer) window.dataLayer = [];

  function getAnonId() {
    try {
      var k = '__dl_anon_id';
      var v = localStorage.getItem(k);
      if (v) return v;
      var r = 'anon_' + Math.random().toString(16).slice(2) + Date.now().toString(16);
      localStorage.setItem(k, r);
      return r;
    } catch (e) {
      return 'anon_' + Math.random().toString(16).slice(2) + Date.now().toString(16);
    }
  }

  function safeText(v) {
    return v == null ? '' : String(v);
  }

  function sha256Hex(str) {
    try {
      if (!window.crypto || !window.crypto.subtle || !window.TextEncoder) return Promise.resolve('');
      var data = new TextEncoder().encode(str);
      return window.crypto.subtle.digest('SHA-256', data).then(function(buf) {
        var bytes = new Uint8Array(buf);
        var out = '';
        for (var i = 0; i < bytes.length; i++) out += bytes[i].toString(16).padStart(2, '0');
        return out;
      }).catch(function() { return ''; });
    } catch (e) {
      return Promise.resolve('');
    }
  }

  var customer = window.__DL_CUSTOMER || null;
  var baseCustomerId = customer && customer.id ? safeText(customer.id) : getAnonId();
  var customerType = customer && customer.id ? 'customer' : 'guest';

  var userDataReady = Promise.resolve({ email: '', phone_number: '' });
  if (customer && (customer.email || customer.phone)) {
    var email = safeText(customer.email).trim().toLowerCase();
    var phone = safeText(customer.phone).replace(/\s+/g, '');
    userDataReady = Promise.all([
      email ? sha256Hex(email) : Promise.resolve(''),
      phone ? sha256Hex(phone) : Promise.resolve('')
    ]).then(function(arr) {
      return { email: arr[0] || '', phone_number: arr[1] || '' };
    });
  }

  function getItemFromCard(card) {
    if (!card) return null;
    var itemId = safeText(card.getAttribute('data-dl-item-id')).trim();
    var itemName = safeText(card.getAttribute('data-dl-item-name')).trim();
    if (!itemId && !itemName) return null;
    var price = parseFloat(safeText(card.getAttribute('data-dl-price')).trim());
    if (isNaN(price)) price = undefined;
    return {
      item_id: itemId || undefined,
      item_name: itemName || undefined,
      item_brand: safeText(card.getAttribute('data-dl-item-brand')).trim() || undefined,
      item_category: safeText(card.getAttribute('data-dl-item-category')).trim() || undefined,
      item_variant: safeText(card.getAttribute('data-dl-item-variant')).trim() || undefined,
      price: price,
      quantity: 1
    };
  }

  function getItemFromEl(el) {
    if (!el) return null;
    var itemId = safeText(el.getAttribute('data-dl-item-id')).trim();
    var itemName = safeText(el.getAttribute('data-dl-item-name')).trim();
    if (!itemId && !itemName) return null;
    var price = parseFloat(safeText(el.getAttribute('data-dl-price')).trim());
    if (isNaN(price)) price = undefined;
    return {
      item_id: itemId || undefined,
      item_name: itemName || undefined,
      affiliation: safeText(el.getAttribute('data-dl-affiliation')).trim() || undefined,
      item_brand: safeText(el.getAttribute('data-dl-item-brand')).trim() || undefined,
      item_category: safeText(el.getAttribute('data-dl-item-category')).trim() || undefined,
      item_variant: safeText(el.getAttribute('data-dl-item-variant')).trim() || undefined,
      price: price,
      quantity: 1
    };
  }

  function getListMeta(card) {
    var listId = '';
    var listName = '';
    try {
      var el = card && card.closest ? card.closest('[data-item-list-id], [data-item-list-name]') : null;
      if (el) {
        listId = safeText(el.getAttribute('data-item-list-id')).trim();
        listName = safeText(el.getAttribute('data-item-list-name')).trim();
      }
    } catch (e) {}
    if (!listId) listId = safeText(window.location.pathname || '').replace(/\/+$/, '') || '/';
    if (!listName) listName = document.title || listId;
    return { item_list_id: listId, item_list_name: listName };
  }

  function pushSelectItem(card) {
    var item = getItemFromEl(card);
    if (!item) return;
    var meta = getListMeta(card);
    userDataReady.then(function(u) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'select_item',
        customer_type: customerType,
        customer_id: baseCustomerId,
        ecommerce: {
          item_list_id: meta.item_list_id,
          item_list_name: meta.item_list_name,
          items: [item]
        },
        user_data: {
          email: u.email || '',
          phone_number: u.phone_number || ''
        }
      });
    });
  }

  document.addEventListener('click', function(e) {
    var t = e.target;
    if (!t) return;
    var link = t.closest ? t.closest('a') : null;
    if (!link) return;
    var card = link.closest ? link.closest('.product-card') : null;
    if (!card) return;
    var href = link.getAttribute('href') || '';
    if (!href || href.indexOf('#') === 0) return;
    pushSelectItem(card);
  }, { capture: true });

  function pushViewItemFromPage() {
    var p = window.__DL_PRODUCT || null;
    if (!p || !p.item) return;
    userDataReady.then(function(u) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'view_item',
        customer_type: customerType,
        customer_id: baseCustomerId,
        ecommerce: {
          currency: safeText(p.currency) || undefined,
          value: typeof p.value === 'number' ? p.value : undefined,
          items: [p.item]
        },
        user_data: {
          email: u.email || '',
          phone_number: u.phone_number || ''
        }
      });
    });
  }

  function getItemFromCardWithIndex(card, index) {
    var item = getItemFromEl(card);
    if (!item) return null;
    item.index = index;
    return item;
  }

  function trackAddToCartFromForm(form, quantity) {
    if (!form) return;
    var qty = parseInt(quantity, 10);
    if (isNaN(qty) || qty < 1) qty = 1;

    var item = getItemFromEl(form);
    if (!item && window.__DL_PRODUCT && window.__DL_PRODUCT.item) {
      item = Object.assign({}, window.__DL_PRODUCT.item);
    }
    if (!item) {
      var card = form.closest ? form.closest('.product-card') : null;
      item = getItemFromEl(card);
    }
    if (!item) return;

    item.quantity = qty;
    var currency = safeText(window.__DL_CURRENCY || '') || undefined;
    var price = typeof item.price === 'number' ? item.price : undefined;
    var value = price != null ? price * qty : undefined;

    userDataReady.then(function(u) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        customer_type: customerType,
        customer_id: baseCustomerId,
        ecommerce: {
          currency: currency,
          value: value,
          items: [item]
        },
        user_data: {
          email: u.email || '',
          phone_number: u.phone_number || ''
        }
      });
    });
  }

  window.__DL_trackAddToCart = trackAddToCartFromForm;

  function trackAddToCartFromBundleResponse(resp, fallbackItems) {
    var currency = safeText(window.__DL_CURRENCY || '') || undefined;
    var outItems = [];

    function pushFallback() {
      try {
        var arr = Array.isArray(fallbackItems) ? fallbackItems : [];
        for (var i = 0; i < arr.length; i++) {
          var it = arr[i] || {};
          var id = safeText(it.id || '').trim();
          if (!id) continue;
          var qty = parseInt(it.quantity, 10);
          if (isNaN(qty) || qty < 1) qty = 1;
          outItems.push({ item_id: id, quantity: qty });
        }
      } catch (e) {}
    }

    try {
      var arr2 = [];
      if (Array.isArray(resp)) arr2 = resp;
      else if (resp && Array.isArray(resp.items)) arr2 = resp.items;
      else if (resp && Array.isArray(resp.added)) arr2 = resp.added;
      if (arr2 && arr2.length) {
        for (var j = 0; j < arr2.length; j++) {
          var r = arr2[j] || {};
          var itemId = safeText(r.sku || r.id || r.variant_id || '').trim();
          var itemName = safeText(r.product_title || r.title || r.name || '').trim();
          var qty2 = parseInt(r.quantity, 10);
          if (isNaN(qty2) || qty2 < 1) qty2 = 1;
          var price2 = typeof r.price === 'number' ? r.price / 100 : undefined;
          outItems.push({
            item_id: itemId || undefined,
            item_name: itemName || undefined,
            price: price2,
            quantity: qty2
          });
        }
      } else {
        pushFallback();
      }
    } catch (e2) {
      pushFallback();
    }

    if (!outItems.length) return;
    var value = 0;
    var hasValue = false;
    for (var k = 0; k < outItems.length; k++) {
      var pr = outItems[k].price;
      var qt = outItems[k].quantity;
      if (typeof pr === 'number' && typeof qt === 'number') {
        value += pr * qt;
        hasValue = true;
      }
    }

    userDataReady.then(function(u) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_cart',
        customer_type: customerType,
        customer_id: baseCustomerId,
        ecommerce: {
          currency: currency,
          value: hasValue ? value : undefined,
          items: outItems
        },
        user_data: {
          email: u.email || '',
          phone_number: u.phone_number || ''
        }
      });
    });
  }

  window.__DL_trackAddToCartBundle = trackAddToCartFromBundleResponse;

  function normalizeCartItems(cart) {
    try {
      var items = [];
      var arr = cart && Array.isArray(cart.items) ? cart.items : [];
      for (var i = 0; i < arr.length; i++) {
        var it = arr[i] || {};
        var itemId = safeText(it.sku || it.variant_id || it.id || '').trim();
        var itemName = safeText(it.product_title || it.title || it.name || '').trim();
        var qty = parseInt(it.quantity, 10);
        if (isNaN(qty) || qty < 1) qty = 1;
        var price = typeof it.price === 'number' ? it.price / 100 : undefined;
        items.push({
          item_id: itemId || undefined,
          item_name: itemName || undefined,
          affiliation: safeText(it.vendor || '') || undefined,
          item_brand: safeText(it.vendor || '') || undefined,
          item_category: safeText(it.product_type || '') || undefined,
          item_variant: safeText(it.variant_title || '') || undefined,
          price: price,
          quantity: qty
        });
      }
      return items;
    } catch (e) {
      return [];
    }
  }

  function cartKeyFromLine(line) {
    try {
      if (!line) return '';
      var sku = safeText(line.sku || '').trim();
      if (sku) return sku;
      var vid = safeText(line.variant_id || line.id || '').trim();
      return vid;
    } catch (e) {
      return '';
    }
  }

  function normalizeCartLinesByKey(cart) {
    try {
      var out = {};
      var arr = cart && Array.isArray(cart.items) ? cart.items : [];
      for (var i = 0; i < arr.length; i++) {
        var it = arr[i] || {};
        var key = cartKeyFromLine(it);
        if (!key) continue;
        out[key] = it;
      }
      return out;
    } catch (e) {
      return {};
    }
  }

  function buildEcomItemFromCartLine(line, quantity) {
    if (!line) return null;
    var qty = parseInt(quantity, 10);
    if (isNaN(qty) || qty < 1) qty = 1;
    var itemId = safeText(line.sku || line.variant_id || line.id || '').trim();
    var itemName = safeText(line.product_title || line.title || line.name || '').trim();
    var price = typeof line.price === 'number' ? line.price / 100 : undefined;
    return {
      item_id: itemId || undefined,
      item_name: itemName || undefined,
      affiliation: safeText(line.vendor || '') || undefined,
      item_brand: safeText(line.vendor || '') || undefined,
      item_category: safeText(line.product_type || '') || undefined,
      item_variant: safeText(line.variant_title || '') || undefined,
      price: price,
      quantity: qty
    };
  }

  function pushViewCart(cart) {
    var items = normalizeCartItems(cart);
    window.__DL_lastCartLines = normalizeCartLinesByKey(cart);
    var currency = safeText(window.__DL_CURRENCY || '') || undefined;
    var value = cart && typeof cart.total_price === 'number' ? cart.total_price / 100 : undefined;
    userDataReady.then(function(u) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'view_cart',
        customer_type: customerType,
        customer_id: baseCustomerId,
        ecommerce: {
          currency: currency,
          value: value,
          items: items
        },
        user_data: {
          email: u.email || '',
          phone_number: u.phone_number || ''
        }
      });
    });
  }

  function pushRemoveFromCart(items) {
    if (!items || !items.length) return;
    var currency = safeText(window.__DL_CURRENCY || '') || undefined;
    var value = 0;
    var hasValue = false;
    for (var i = 0; i < items.length; i++) {
      var it = items[i] || {};
      if (typeof it.price === 'number' && typeof it.quantity === 'number') {
        value += it.price * it.quantity;
        hasValue = true;
      }
    }
    userDataReady.then(function(u) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'remove_from_cart',
        customer_type: customerType,
        customer_id: baseCustomerId,
        ecommerce: {
          currency: currency,
          value: hasValue ? value : undefined,
          items: items
        },
        user_data: {
          email: u.email || '',
          phone_number: u.phone_number || ''
        }
      });
    });
  }

  function handleCartUpdated(cart) {
    try {
      if (!cart) return;
      var prev = window.__DL_lastCartLines || {};
      var next = normalizeCartLinesByKey(cart);
      var removed = [];
      Object.keys(prev).forEach(function(key) {
        var a = prev[key];
        var b = next[key];
        var qa = a && a.quantity != null ? parseInt(a.quantity, 10) : 0;
        if (isNaN(qa) || qa < 0) qa = 0;
        var qb = b && b.quantity != null ? parseInt(b.quantity, 10) : 0;
        if (isNaN(qb) || qb < 0) qb = 0;
        if (qb < qa) {
          var delta = qa - qb;
          var item = buildEcomItemFromCartLine(a, delta);
          if (item) removed.push(item);
        }
      });
      window.__DL_lastCartLines = next;
      if (removed.length) pushRemoveFromCart(removed);
    } catch (e) {}
  }

  function hookCartDrawerOpen() {
    if (window.__DL_cartDrawerHooked) return;
    window.__DL_cartDrawerHooked = true;
    var orig = window.openCartDrawer;
    if (typeof orig !== 'function') return;
    window.openCartDrawer = function() {
      var ret = orig.apply(this, arguments);
      try {
        if (ret && typeof ret.then === 'function') {
          ret.then(function(cart) { if (cart) pushViewCart(cart); });
        } else {
          fetch('/cart.js')
            .then(function(r) { return r.ok ? r.json() : null; })
            .then(function(c) { if (c) pushViewCart(c); })
            .catch(function() {});
        }
      } catch (e) {}
      return ret;
    };
  }

  function pushViewCartOnCartPage() {
    try {
      var p = safeText(window.location.pathname || '');
      if (!p) return;
      p = p.replace(/\/+$/, '');
      if (p !== '/cart') return;
      fetch('/cart.js')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(c) { if (c) pushViewCart(c); })
        .catch(function() {});
    } catch (e) {}
  }

  document.addEventListener('cart:updated', function(e) {
    try {
      var cart = e && e.detail && e.detail.cart ? e.detail.cart : null;
      handleCartUpdated(cart);
    } catch (err) {}
  });

  function pushBeginCheckout(cart) {
    var items = normalizeCartItems(cart);
    var currency = safeText(window.__DL_CURRENCY || '') || undefined;
    var value = cart && typeof cart.total_price === 'number' ? cart.total_price / 100 : undefined;
    userDataReady.then(function(u) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'begin_checkout',
        customer_type: customerType,
        customer_id: baseCustomerId,
        ecommerce: {
          currency: currency,
          value: value,
          items: items
        },
        user_data: {
          email: u.email || '',
          phone_number: u.phone_number || ''
        }
      });
    });
  }

  function hookBeginCheckoutButtons() {
    if (window.__DL_beginCheckoutHooked) return;
    window.__DL_beginCheckoutHooked = true;

    document.addEventListener('submit', function(e) {
      var form = e.target;
      if (!form || !form.querySelector) return;
      var btn = form.querySelector('button[name="checkout"]');
      if (!btn) return;
      if (form.dataset && form.dataset.dlBeginCheckoutBound === '1') return;
      if (form.dataset) form.dataset.dlBeginCheckoutBound = '1';
      fetch('/cart.js')
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(c) { if (c) pushBeginCheckout(c); })
        .catch(function() {});
    }, { capture: true });
  }

  function pushViewItemListFromPage() {
    if (window.__DL_PRODUCT) return;
    var cards = document.querySelectorAll('.product-card[data-dl-item-name], .product-card[data-dl-item-id]');
    if (!cards || !cards.length) return;

    var firstCard = cards[0];
    var meta = getListMeta(firstCard);
    var items = [];
    for (var i = 0; i < cards.length; i++) {
      var it = getItemFromCardWithIndex(cards[i], i);
      if (it) {
        it.item_list_id = meta.item_list_id || undefined;
        it.item_list_name = meta.item_list_name || undefined;
        items.push(it);
      }
      if (items.length >= 50) break;
    }
    if (!items.length) return;

    userDataReady.then(function(u) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'view_item_list',
        customer_type: customerType,
        customer_id: baseCustomerId,
        ecommerce: {
          item_list_id: meta.item_list_id,
          item_list_name: meta.item_list_name,
          items: items
        },
        user_data: {
          email: u.email || '',
          phone_number: u.phone_number || ''
        }
      });
    });
  }

  function trackAddToWishlist() {
    var p = window.__DL_PRODUCT || null;
    if (!p || !p.item) return;
    var currency = safeText(window.__DL_CURRENCY || '') || undefined;
    var value = typeof p.value === 'number' ? p.value : (typeof p.item.price === 'number' ? p.item.price : undefined);
    userDataReady.then(function(u) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'add_to_wishlist',
        customer_type: customerType,
        customer_id: baseCustomerId,
        ecommerce: {
          currency: currency,
          value: value,
          items: [p.item]
        },
        user_data: {
          email: u.email || '',
          phone_number: u.phone_number || ''
        }
      });
    });
  }

  window.__DL_trackWishlistAdd = trackAddToWishlist;

  function trackQuizStart(quizName, ctaLabel) {
    userDataReady.then(function(u) {
      window.dataLayer.push({
        event: 'lookcare_quiz_start',
        quiz_name: quizName || 'lookcare_routine',
        step_number: 0,
        step_name: 'start',
        cta_label: ctaLabel || 'Rutinini Keşfet',
        user_id: baseCustomerId,
        login_status: customerType,
        email_hashed: u.email || '',
        phone_hashed: u.phone_number || ''
      });
    });
  }

  window.__DL_trackQuizStart = trackQuizStart;

  function trackQuizStep(data) {
    userDataReady.then(function(u) {
      window.dataLayer.push({
        event: 'lookcare_quiz_step',
        quiz_name: data.quiz_name || 'lookcare_routine',
        step_number: data.step_number,
        step_name: data.step_name,
        question: data.question,
        selected_option: data.selected_option,
        selected_option_label: data.selected_option_label,
        user_id: baseCustomerId,
        login_status: customerType,
        email_hashed: u.email || '',
        phone_hashed: u.phone_number || ''
      });
    });
  }

  window.__DL_trackQuizStep = trackQuizStep;

  function trackQuizComplete(data) {
    userDataReady.then(function(u) {
      window.dataLayer.push({
        event: 'lookcare_quiz_complete',
        quiz_name: data.quiz_name || 'lookcare_routine',
        step_number: 4,
        step_name: 'results',
        lifestyle: data.lifestyle,
        routine_time: data.routine_time,
        profile: data.profile,
        recommended_routine: data.recommended_routine,
        recommended_products: data.recommended_products,
        product_count: data.product_count,
        user_id: baseCustomerId,
        login_status: customerType,
        email_hashed: u.email || '',
        phone_hashed: u.phone_number || ''
      });
    });
  }

  window.__DL_trackQuizComplete = trackQuizComplete;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      pushViewItemFromPage();
      pushViewItemListFromPage();
      hookCartDrawerOpen();
      pushViewCartOnCartPage();
      hookBeginCheckoutButtons();
    });
  } else {
    pushViewItemFromPage();
    pushViewItemListFromPage();
    hookCartDrawerOpen();
    pushViewCartOnCartPage();
    hookBeginCheckoutButtons();
  }
})();

